import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { Search } from 'shared/@generated/models';

export function mergeSearch(existing: Search, search: Search): Search {
  return {
    ...existing,
    ...search,
    search_breeds: search.search_breeds ?? existing.search_breeds,
    search_matches: search.search_matches ?? existing.search_matches,
    unseen_search_matches: search.unseen_search_matches ?? existing.unseen_search_matches,
    search_matches_count: search.search_matches_count ?? existing.search_matches_count,
    unseen_search_matches_count:
      search.unseen_search_matches_count ?? existing.unseen_search_matches_count,
  };
}

const useSearchesStore = create(
  combine(
    {
      searches: [] as Search[],
    },
    (set, _get) => ({
      setup: (searches: Search[]) => {
        set({ searches });
      },
      reset: () => {
        set({ searches: [] });
      },
      add: (search: Search) => set((state) => ({ searches: [...state.searches, search] })),
      update: (search: Search) =>
        set((state) => ({
          searches: state.searches.map((existing) =>
            existing.uuid === search.uuid ? mergeSearch(existing, search) : existing,
          ),
        })),
      remove: (uuid: string) =>
        set((state) => ({
          searches: state.searches.filter((search) => search.uuid !== uuid),
        })),
    }),
  ),
);

export default useSearchesStore;
